import { render, staticRenderFns } from "./ServicePaymentDetailInvoice.vue?vue&type=template&id=6bf52834&"
import script from "./ServicePaymentDetailInvoice.vue?vue&type=script&lang=js&"
export * from "./ServicePaymentDetailInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports